/* eslint-disable no-console */
import { ApplicationRef, Injectable, NgZone } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { UnsubscribeComponent } from 'app/shared-components/components/unsubscribe/unsubscribe.abstract';
import { concat, interval, Subscription } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class WebUpdateService extends UnsubscribeComponent {

    intervalSource = interval(15 * 60 * 1000); // every 15 mins
    intervalSubscription: Subscription;

    constructor(
        private readonly updates: SwUpdate,
        private appRef: ApplicationRef,
        private zone: NgZone
    ) {
        super();

        this.intervalSubscription?.unsubscribe();

        this.updates.unrecoverable.pipe(takeUntil(this.unsubscriber)).subscribe(event => {
            // An error has occurred with service worker. Force a refresh
            window.location.reload();
        }, (error) => {
            if (location.hostname.includes('devg3') || location.hostname.includes('localhost')) {
                console.log(error);
            }
        });

        this.updates.checkForUpdate();

        this.updates.versionUpdates.pipe(takeUntil(this.unsubscriber)).subscribe(event => {
            this.updates.activateUpdate().then(() => {
                window.location.reload();
            });
        }, (error) => {
            if (location.hostname.includes('devg3') || location.hostname.includes('localhost')) {
                console.log(error);
            }
        });

        // Allow the app to stabilize first, before starting
        // polling for updates with `interval()`.
        const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
        const everyHour$ = interval(1 * 60 * 60 * 1000);
        const everyHourOnceAppIsStable$ = concat(appIsStable$, everyHour$);
        everyHourOnceAppIsStable$.pipe(takeUntil(this.unsubscriber)).subscribe(() => {
            this.updates.checkForUpdate()
        }, (error) => {
            if (location.hostname.includes('devg3') || location.hostname.includes('localhost')) {
                console.log(error);
            }
        });

        // Check immediately once app is ready
        appIsStable$.pipe(takeUntil(this.unsubscriber)).subscribe(() => {
            this.updates.checkForUpdate()
        }, (error) => {
            if (location.hostname.includes('devg3') || location.hostname.includes('localhost')) {
                console.log(error);
            }
        });

        this.zone.runOutsideAngular(() => {
            this.intervalSubscription = this.intervalSource
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(async () => {
                try {
                    var isNewVersionAvailable = await this.updates.checkForUpdate();
                    console.log(isNewVersionAvailable);
                    if (isNewVersionAvailable) {
                        window.location.reload();
                    } else {
                        if (location.hostname.includes('devg3') || location.hostname.includes('localhost')) {
                            console.log('No new version available');
                        }
                    }
                } catch (error) {
                    if (location.hostname.includes('devg3') || location.hostname.includes('localhost')) {
                        console.log(error);
                    }
                }
            });
        })
    }
}
